import { Alert, Button } from 'react-bootstrap';
import { centralEnabled } from '@/config/api'
import { CentralAccess } from '@/pages/CentralAccounts'
import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { AuthStatus } from './AuthStatus'
import { useAuth } from '@/context/AuthContext'

export function RequireAuth() {
  const { session, ready, isDemo, accessError, retryAccess } = useAuth()
  const location = useLocation()

  if (accessError) return <Alert variant="warning">Unable to verify CRM access right now. <Button onClick={retryAccess}>Retry</Button></Alert>;

  if (!ready) {
    return <AuthStatus product="CRM" />
  }

  if (!session) {
    return <Navigate to="/signin" replace state={{ from: location.pathname + location.search + location.hash }} />
  }

  if (session.requiresBusinessSelection || session.purpose === 'select') {
    return <Navigate to="/select-business" replace state={{ returnTo: location.pathname + location.search + location.hash }} />
  }

  return centralEnabled && !isDemo ? <CentralAccess><Outlet /></CentralAccess> : <Outlet />
}

export function RequireRole({ roles, children }: { roles: string[]; children: ReactNode }) {
  const { session } = useAuth()
  if (!session?.role || !roles.includes(session.role)) {
    return <Navigate to="/" replace />
  }
  return children
}
